import { FormControl } from '@mui/material';
import styled from 'styled-components';

import { StyledLoadingButton } from '../../../components/forms/LoadingButton';

export const FormFields = styled.div`
    margin-bottom: 0.5rem;
    width: 100%;
`;

export const StyledFormControl = styled(FormControl)`
    margin-bottom: 0.5rem;
`;

export const FormContainer = styled.div`
    display: flex;
    align-items: center;
    flex-direction: column;
    width: 100%;

    form {
        display: flex;
        align-items: center;
        flex-direction: column;
        width: 100%;
        margin-bottom: 1rem;
    }
`;

export const ResetButton = styled(StyledLoadingButton)`
    padding: 0.5rem 0.75rem;
    font-size: 16px;
`;

export const ButtonText = styled.div`
    display: flex;
    align-items: center;

    svg {
        width: 18px;
        margin-left: 0.5rem;
    }
`;

export const HelperText = styled.div`
    font-size: 12px;
    line-height: 20px;
`;

export const Navigation = styled.div`
    margin-bottom: 1rem;
`;
